import React from 'react';
import Footer from '../footer/Footer';
import ReactGA from 'react-ga';
import { connect } from 'react-redux'
import { fetchEvents } from '../../actions'
import { Link } from 'react-router-dom';
import { Divider } from 'semantic-ui-react'
import { renderPanes } from './eventUtils/eventListUtils'
import { currentMonth } from '../helpers/DateUtils'

class EventList extends React.Component { 

  componentDidMount(){
    ReactGA.ga('send', 'pageview', '/events/list');
  }

  onSubmit = (formValues) => {
    console.log(formValues);
    this.props.createEvent(formValues);
  }
 
  renderCreate() {
    if(this.props.isSignedIn){
      return (
        <React.Fragment>
          <Link to="/events/new" className="ui positive button primary" >
            Create New Event
          </Link>
        </React.Fragment>
      );
    }
  }
  
 render () {
      if(!this.props.events || this.props.events === null){
        return <div className="ui container">{this.renderCreate()}</div>;
      }
      else{
        return (
          <React.Fragment>
            <div className="ui container">
              <h2>Games</h2>
              {this.renderCreate()}
              <Divider hidden />
              <h4 className="ui header">Refine results by selecting the tabs provided</h4>
              <Divider hidden />
              {renderPanes(this.props.events,this.props.isSignedIn, currentMonth())}
            </div>
           <Footer/>
          </React.Fragment>
        );
      }
  }
};

const mapStateToProps = (state) => {
  return {
    events: state.events,
    isSignedIn: state.auth.token !== null
  };
}

export default connect(
  mapStateToProps,
  { fetchEvents }
)(EventList);
